/* eslint-disable flowtype/require-valid-file-annotation */
import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import $ from "jquery";
import HoursHour from "./HoursHour";
import C from "./../../Constants";

const styles = theme => ({
    hoursDateHeaderSticky: {
        alignItems: "center",
    },
    hoursDateHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "sticky",
        top: 0,
        //width: "100%",
        backgroundColor: "white",
    },
    hourEntryName: {},
    hourEntryContact: {},
    dateIsSelected: {
        backgroundColor: theme.palette.secondary,
    },
    day: {width: "100%",},
    hour: {},
    raster: {},
    hourRasterDense: {},
    hourRasterWide: {},
    dayRasterDense: {},
    dayRasterWide: {},
});

class HoursDay extends React.Component {
    render() {
        const {classes} = this.props;
        const dayWidthClass = this.props.dense ? " " + classes.dayRasterDense : " " + classes.dayRasterWide;
        return <div className={classes.day + dayWidthClass} id={"d" + this.props.date.format(C.inputDatePatternMomentScriptId)}>
            {this.renderAllHoursOfDay()}
        </div>;
    }

    hourSelected = (date, hour) => () => this.props.container.hourSelected(date, hour);
    hourHovered = (date, hour) => () => this.props.container.hourHovered(date, hour);

    renderAllHoursOfDay = () => {
        const {classes} = this.props;
        const date = this.props.date;
        const wholeDay = [];
        const hourHeightClass = this.props.dense ? " " + classes.hourRasterDense : " " + classes.hourRasterWide;
        for (let i = 0; i < 24; i++) wholeDay[i] = this.props.hoursOfDay[i];
        return $.map(wholeDay, (hourEntries, hourNumber) => {
            return <HoursHour
                key={hourNumber} hourNumber={hourNumber}
                onClick={this.hourSelected(date, hourNumber)} onHover={this.hourHovered(date, hourNumber)}
                className={hourHeightClass} dense={this.props.dense}
                classes={{raster: classes.raster, day: classes.day,hour: classes.hour,
                    hourRasterDense: classes.hourRasterDense, hourRasterWide: classes.hourRasterWide}}
                hourEntries={hourEntries} hourTypes={this.props.hourTypes}/>;
        });
    }


}

HoursDay.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(HoursDay, {name: "hourPanel"});